import styled from '@emotion/styled';

export const P = styled.p`
  font-size: 1rem;
  line-height: 1.75;
  color: #7e848c;
  width: 100%;
  padding: 5px 0;
  letter-spacing: 0.5px;
  font-weight: 400;
  white-space: pre-wrap;
`;
